// JavaScript для blockquote
import { onReady } from '../base/init.js';

onReady(function () {
  // Код для blockquote
});
